import { rankingTopics } from '@/mocks/gossip';

const deltIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  flat: 'ri-time-line text-foreground-400',
  down: 'ri-arrow-down-line text-accent-600',
};

const tagStyle: Record<string, string> = {
  爆: 'bg-primary-500 text-background-50',
  热: 'bg-primary-100 text-primary-700',
  议: 'bg-accent-500 text-background-50',
  楼: 'bg-accent-100 text-accent-700',
  深: 'bg-secondary-500 text-background-50',
  期: 'bg-secondary-100 text-secondary-700',
};

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-100 py-12 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          {/* 侧边介绍卡 */}
          <div className="order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-8 md:p-10">
              <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-primary-100/70" />
              <div className="absolute -bottom-14 -left-10 h-44 w-44 rounded-full bg-accent-100/60" />
              <div className="relative">
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-bold text-primary-700">
                  <i className="ri-fire-fill" />
                  瓜田实时热榜
                </span>
                <h2 className="mt-5 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-3xl">
                  全网都在聊的
                  <br />
                  最新瓜 TOP 榜
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                  热度实时跳动，前排投票和评论区跟帖都会影响排名。想知道哪口瓜最下饭，先来这瞄一眼。
                </p>
                <a
                  href="#commentBox"
                  className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
                >
                  参与前排投票
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>

          {/* 榜单 */}
          <div className="order-1 lg:order-2">
            <ol className="divide-y divide-background-200 rounded-3xl border border-background-200 bg-background-50/80">
              {rankingTopics.map((t, i) => (
                <li key={i} className="group flex items-center gap-4 px-4 py-4 transition hover:bg-background-50 md:px-6">
                  <span className={`font-heading text-xl font-black md:text-2xl ${i < 3 ? 'text-primary-500' : 'text-background-300'}`}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h4 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">{t.title}</h4>
                      <span className={`hidden shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-black sm:inline-block ${tagStyle[t.tag]}`}>
                        {t.tag}
                      </span>
                    </div>
                    <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <i className="ri-price-tag-3-line text-primary-500" />
                      {t.cat}
                      <span className="text-foreground-300">·</span>
                      {t.heat}万热度
                    </p>
                  </div>
                  <i className={`${deltIcon[t.delta]} flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-sm`} />
                </li>
              ))}
            </ol>
            <div className="mt-4 flex items-center justify-between px-1 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="flex h-1.5 w-1.5 rounded-full bg-accent-500" />
                每 3 分钟按实时热度重排
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-refresh-line text-accent-600" />
                上次更新 10 秒前
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}